<template>
  <div :class="`nnform-element-container m-0 ${this.error ? `has-error`: ``}${this.className}`">
    <div class="nnform-element-wrap --checkbox checkbox">
      <label class="custom-checkbox">
        <input
            class="nnform-element"
            type="checkbox"
            :name="this.name"
            :value="modelValue"
            @input="handler"
        >
        <span>{{ label }}</span>
      </label>
    </div>
    <div class="nnform-error" v-if="this.error">{{ error }}</div>
  </div>
</template>

<script>
export default {
  name: "CheckoutCheckbox",
  props: {
    modelValue: null,
    label: String,
    className: String,
    name: String,
    error: String,
    type: {
      type: String,
      default: 'text',
    },
  },
  methods: {
    handler(e) {
      this.$emit("update:modelValue", e.target.value);
      this.$emit("unset");
    },
  },
}
</script>

<style scoped>

</style>